<template>
    <div class="serach_box">
        <template v-for="item in list" :key="item.text">
        <div v-if="!item.emptyHide || item.options?.length" class="searchItem">
            <label v-if="formateLabel(item)">{{ formateLabel(item) }}</label>
            <el-input @input="seachingText(item)"  v-if="item.type === 'input'" v-model="item.value"
                clearable></el-input>
            <el-select :clearable="item.isClearable" @change="seachingSelect(item)"  filterable
                v-else-if="hideSelect(item)" v-model="item.value" placeholder="请选择">
                <el-option v-for="el in item.options" :key="el.value"
                    :label="item.text === '应用' ? `${el.label} [appId:${el.value}]` : el.label"
                    :value="el.value"></el-option>
            </el-select>
            <div class="selectTitleInput" v-else-if="item.type === 'selectTitleInput'">
                <el-dropdown>
                    <el-button class="el-dropdown-link">
                        {{ item.titleText }}
                        <el-icon class="el-icon--right">
                            <arrow-down />
                        </el-icon>
                    </el-button>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item v-for="title in item?.titleSelectList" @click="changeTitle(title)">{{
                                title.text }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <el-input :aria-label="item.titleText || item.text" :placeholder="'请输入' + (item.titleText || item.text)" class="selectinput" @input="seachingText(item)"  v-model="item.value"
                    clearable></el-input>
            </div>
        </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted } from 'vue'
    interface searchItem {
        text: string
        value: any
        options?: any
        type: string
        mark: string
        isClearable?: boolean
        titleSelectList?: any
        titleText?: string
        emptyHide?: boolean
    }
    const props = defineProps<{ list: searchItem[] }>()
    const emit = defineEmits<{
        (event: 'seraching', data: any, type: string): void
        (event: 'judgeSearch', data: any, type: string): void
        (event: 'changeTitle', title: any): void
    }>()

    let time: any
    const seachingText = (item: any) => {
        clearTimeout(time)
        time = setTimeout(() => {
            emit('seraching', item.value, item.mark)
            emit('judgeSearch', item.value, item.mark)
        }, 500)
    }
    const seachingSelect = (item: any) => {
        emit('seraching', item.value, item.mark)
        emit('judgeSearch', item.value, item.mark)
    }

    const changeTitle = (title: any) => {
        emit('changeTitle', title)
    }

    const formateLabel = (item: any) => {
        if (item.type === 'selectTitleInput') {
            return ''
        } else {
            if (item.emptyHide) {
                if (!item.options.length) {
                    return ''
                } else {
                    return item.text
                }
            } else {
                return item.text
            }
        }
    }
    const hideSelect = (item: any) => {
        if (item.type === 'select') {
            if (item.emptyHide) {
                if (!item.options.length) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        } else {
            false
        }
    }
    onMounted(() => { })
</script>

<style scoped>
.serach_box { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px 20px; min-width: 0; }
.searchItem { display: flex; flex-direction: column; gap: 6px; width: min(100%, 280px); min-width: 0; margin: 0; }
.searchItem > label { font-size: 13px; color: var(--ui-text-secondary); line-height: 20px; }
.searchItem .el-input, .searchItem .el-select { width: 100%; min-width: 0; }
.selectTitleInput { display: flex; align-items: center; gap: 8px; min-width: 0; }
.selectTitleInput .el-dropdown { flex-shrink: 0; }
.selectTitleInput .el-input { flex: 1; }
</style>
